<script lang="ts">
    import GameCard from 'src/components/main/#common/game-card/GameCard.svelte'
    import mergeCatsImage from 'src/components/main/#assets/game-merge-cats.jpg'
    import cryptoDragons from 'src/components/main/#assets/game-crypto-dragons.jpg'
    import legendsOfListeria from 'src/components/main/#assets/legends-of-listeria.jpg'
    import {Link} from 'svelte-routing'
    import {api} from "../../../../../services/api/reallis"
</script>

<section class="game-cards" id="game-cards">
    <div class="container">
        <div class="title">Our <span>games</span></div>
        <div class="main-intro-games">
            <div class="row">
                <!--
                <div class="col-md-4">
                    <GameCard
                        title="Crypto Cats"
                        rating="4.5"
                        reviews="107 943"
                        image={mergeCatsImage}
                        published={true}
                        link="https://play.google.com/store/apps/details?id=com.soul.merge.cat.cute.simulator.adventure"
                    />
                </div>
                <div class="col-md-4">
                    <GameCard
                        title="Crypto Dragons"
                        rating="4.7"
                        reviews="109 433"
                        image={cryptoDragons}
                        published={true}
                        link="https://play.google.com/store/apps/details?id=com.dragons.tokens.crypto"
                    />
                </div>
                -->
                <div class="col-md-4">
                    <GameCard
                        title="Legends Of Listeria"
                        rating="0"
                        reviews="0"
                        image={legendsOfListeria}
                        published={true}
                        link="https://play.google.com/store/apps/details?id=com.game.moba.realis.battle.royale"
                    />
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .game-cards {
        padding-top: 200px;
    }

    .title {
        font-family: 'Anton', sans-serif;
        font-size: 70px;
        font-weight: 400;
        color: white;
        margin: 0 0 50px;
        line-height: 90px;
        text-transform: uppercase;
        letter-spacing: 0.02em;
    }

    .title span {
        color: transparent;
        -webkit-text-stroke: 1px white;
    }

    .game-link img {
        max-width: 100%;
    }

    .game-reviews span {
        color: #515159;
        padding-left: 2px;
    }

    .main-intro :global(svg.star-icon) {
        font-size: 14px;
        color: #F3BD38;
        vertical-align: top !important;
        margin: 5px 0 0 0;
    }

    .main-intro :global(svg.star-icon:first-child) {
        margin-left: 5px;
    }

    @media(max-width: 1400px) {
        .game-cards {
            padding-top: 170px;
        }
    }

    @media(max-width: 1199px) {
        .title {
            font-size: 50px;
            line-height: 70px;
        }
    }

    @media (max-width: 992px) {
        .title {
            font-size: 50px;
            line-height: 70px;
            margin: 0 0 40px;
        }

        .game-cards {
            padding-top: 100px;
        }
    }

    @media (max-width: 767px) {
        .title {
            font-size: 40px;
            line-height: 60px;
            margin: 0 0 30px;
        }

        .game-cards {
            padding-top: 70px;
        }
    }
</style>
